// extracted by mini-css-extract-plugin
export default {"orb":"Orb_orb__ZFF7o","large":"Orb_large__QU9xI","filled":"Orb_filled__CYc52","tilde":"Orb_tilde__X4BZH"};